/**
 * Open employee profile (users.id) in a new browser tab.
 *
 * @param {import('vue-router').Router} router
 * @param {number|string|null|undefined} userId
 * @param {Record<string, string|number|boolean|null|undefined>} [query]
 */
export function openEmployeeProfile(router, userId, query = {}) {
  const id = Number(userId);
  if (!Number.isInteger(id) || id <= 0) return;

  try {
    const resolved = router.resolve({
      name: 'employee-detail',
      params: { id: String(id) },
      query,
    });
    window.open(resolved.href, '_blank', 'noopener,noreferrer');
  } catch {
    window.open(`/employees/${id}`, '_blank', 'noopener,noreferrer');
  }
}
